import Vue from 'vue'
import VueRouter from 'vue-router'
const Home = () => import(/* webpackChunkName: "Home" */'@/pages/Home')
const G3PreIntro = () => import(/* webpackChunkName: "Home" */'@/pages/landing-page/g3-pre-intro')
const MyTrain = () => import(/* webpackChunkName: "MyTrain" */'@/pages/MyTrain')
const medicalHome = () => import(/* webpackChunkName: "MyTrain" */'@/pages/medicalHome')
const MyOrder = () => import(/* webpackChunkName: "MyOrder" */'@/pages/MyOrder')
const MyReport = () => import(/* webpackChunkName: "MyReport" */'@/pages/MyReport')
const Product = () => import(/* webpackChunkName: "Product" */'@/pages/Product')
const Confirm = () => import(/* webpackChunkName: "Confirm" */'@/pages/Confirm')
const Game = () => import(/* webpackChunkName: "Game" */'@/pages/Game')
const Question = () => import(/* webpackChunkName: "Question" */'@/pages/Question')
const Complete = () => import(/* webpackChunkName: "Complete" */'@/pages/Complete')
const Error = () => import(/* webpackChunkName: "Error" */'@/pages/Error')
const G3Report = () => import(/* webpackChunkName: "G3-report" */'@/pages/survey/G3-report')
const machineReport = () => import(/* webpackChunkName: "G3-report" */'@/pages/survey/machine-report')
const Agreement = () => import(/* webpackChunkName: "Agreement" */'@/pages/Agreement')
const Privacy = () => import(/* webpackChunkName: "Privacy" */'@/pages/Privacy')
const openingDay = () => import(/* webpackChunkName: "Privacy" */'@/pages/opening-day')
const WechatH5 = () => import(/* webpackChunkName: "wechatH5" */'@/pages/wechatH5')
const G3InfoInput = () => import(/* webpackChunkName: "Question" */'@/pages/survey/G3-info-input')
const G3InfoInputV2 = () => import(/* webpackChunkName: "Question" */'@/pages/survey/G3-info-input-v2')
const InfoInputV3 = () => import(/* webpackChunkName: "Question" */'@/pages/survey/G3-info-input-3')
const G3Introduce = () => import(/* webpackChunkName: "Question" */'@/pages/survey/G3-introduce')
const G3IntroduceHistory = () => import(/* webpackChunkName: "Question" */'@/pages/survey/G3-introduce-history')
const G3TransferGuide = () => import(/* webpackChunkName: "Question" */'@/pages/survey/G3-transfer-guide')
const G3TransferCheck = () => import(/* webpackChunkName: "Question" */'@/pages/survey/G3-transfer-check')
const InsuranceIntroduce = () => import(/* webpackChunkName: "Question" */'@/pages/insurance/Insurance-introduce')
const GoBack = () => import(/* webpackChunkName: "GoBack" */'@/pages/GoBack')
const G3Information = () => import(/* webpackChunkName: "Face" */'@/pages/face/g3-information')
const FaceExample = () => import(/* webpackChunkName: "Face" */'@/pages/face/face-example')
const FaceRecognition = () => import(/* webpackChunkName: "Face" */'@/pages/face/face-recognition')
const BBRTConfirm = () => import(/* webpackChunkName: "BBRTConfirm" */'@/pages/bbrt-confirm')
const Login = () => import(/* webpackChunkName: "Home" */'@/pages/Login')
const SCSReport = () => import(/* webpackChunkName: "SCSReport" */'@/pages/ScsRpeort-summary_alipay')
const Insure = () => import(/* webpackChunkName: "Insure" */'@/pages/zhongan/Insure')
const Introduce = () => import(/* webpackChunkName: "Introduce" */'@/pages/zhongan/Introduce')
const EnsureDetails = () => import(/* webpackChunkName: "EnsureDetails" */'@/pages/zhongan/EnsureDetails')
const HealthNotification = () => import(/* webpackChunkName: "HealthNotification" */'@/pages/zhongan/HealthNotification')
const Success = () => import(/* webpackChunkName: "Success" */'@/pages/zhongan/Success')
const OrderDetails = () => import(/* webpackChunkName: "OrderDetails" */'@/pages/zhongan/OrderDetails')
const InfoConfirm = () => import(/* webpackChunkName: "InfoConfirm" */'@/pages/zhongan/InfoConfirm')
const agentLogin = () => import(/* webpackChunkName: "agentLogin" */'@/pages/agent-tools/agent-login')
const agentMy = () => import(/* webpackChunkName: "agentMy" */'@/pages/agent-tools/agent-my')
const personalLink = () => import(/* webpackChunkName: "personalLink" */'@/pages/side-tools/personal-link')
const productUse = () => import(/* webpackChunkName: "productUse" */'@/pages/side-tools/product-use')
const userBehaPath = () => import(/* webpackChunkName: "userBehaPath" */'@/pages/side-tools/user-beha-path')
const userSource = () => import(/* webpackChunkName: "userSource" */'@/pages/side-tools/user-source')
const userProfile = () => import(/* webpackChunkName: "userProfile" */'@/pages/side-tools/user-profile')
const userTag = () => import(/* webpackChunkName: "userTags" */'@/pages/side-tools/user-tag')
const userReport = () => import(/* webpackChunkName: "userReport" */'@/pages/side-tools/user-report')
const userReportList = () => import(/* webpackChunkName: "userReportList" */'@/pages/side-tools/user-report-list')
const agentOrdeDetails = () => import(/* webpackChunkName: "agentOrdeDetails" */'@/pages/agent-tools/agent-ordeDetails')
const agentWithdrawalDetails = () => import(/* webpackChunkName: "agentWithdrawalDetails" */'@/pages/agent-tools/agent-withdrawalDetails')
const userTrainReportList = () => import(/* webpackChunkName: "userReportList" */'@/pages/side-tools/user-train-report-list')
const ProductConfirm = () => import(/* webpackChunkName: "ProductConfirm" */'@/pages/zhongan/ProductConfirm')
const productFactory = () => import(/* webpackChunkName: "productFactory" */'@/pages/product-factory')
const lotteryDrainage = () => import(/* webpackChunkName: "productFactory" */'@/pages/lottery-drainage')
const luckyDraw = () => import(/* webpackChunkName: "productFactory" */'@/pages/lucky-draw')
const prizeDetail = () => import(/* webpackChunkName: "productFactory" */'@/pages/prize-detail')
const scanCode = () => import(/* webpackChunkName: "scanCode" */'@/pages/Bind/succcess')
const cantactKefu = () => import(/* webpackChunkName: "cantactKefu" */'@/pages/contactKefu/contactKefu')
const transitPage = () => import(/* webpackChunkName: "transitPage" */'@/pages/transit-page/transit-page')
const dynamicPage = () => import(/* webpackChunkName: "transitPage" */'@/pages/dynamic/dynamic')
const turtleSoup = () => import(/* webpackChunkName: "transitPage" */'@/pages/turtle-soup/turtle-soup')
const aiChat = () => import(/* webpackChunkName: "transitPage" */'@/pages/ai-chat/ai-chat')
const employeeHandbook = () => import(/* webpackChunkName: "employeeHandbook" */'@/pages/employeeHandbook')
const healthQuestionnaire = () => import(/* webpackChunkName: "Question" */'@/pages/survey/health-questionnaire')
const dynamicQuestionnaire = () => import(/* webpackChunkName: "Question" */'@/pages/dynamic-questionnaire/dynamic-questionnaire')
const surveyList = () => import(/* webpackChunkName: "Question" */'@/pages/hospital/survey-list')
const surveyListZhongShan = () => import(/* webpackChunkName: "Question" */'@/pages/hospital/survey-list-zhongshan')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
	meta: {
	    requireAuth: true,
	},
    component: Home
  },
  {
    path: '/MyTrain',
    name: 'MyTrain',
	meta: {
	    requireAuth: true,
	},
    component: MyTrain
  },
  {
    path: '/medicalHome',
    name: 'medicalHome',
	meta: {
	    requireAuth: false,
	},
    component: medicalHome
  },
  {
    path: '/MyOrder',
    name: 'MyOrder',
	meta: {
	    requireAuth: true,
	},
    component: MyOrder
  },
  {
    path: '/MyReport',
    name: 'MyReport',
	meta: {
	    requireAuth: true,
	},
    component: MyReport
  },
  {
    path: '/Product',
    name: 'Product',
	meta: {
	    requireAuth: true,
	},
    component: Product
  },
  {
    path: '/Confirm',
    name: 'Confirm',
	meta: {
	    requireAuth: true,
	},
    component: Confirm
  },
  {
    path: '/employeeHandbook',
    name: 'employeeHandbook',
  	meta: {
  	    requireAuth: true,
  	},
    component: employeeHandbook
  },
  {
    path: '/Game',
    name: 'Game',
    component: Game,
	meta: {
	    requireAuth: true,
	},
    props:(route) => {
      return {
        taskId:route.query.taskId,
        planId:route.query.planId,
        sectionId:route.query.sectionId
      }
    }
  },
  {
    path: '/Question',
    name: 'Question',
    component: Question,
	meta: {
	    requireAuth: true,
	},
    props:(route) => {
      return {
        taskId:route.query.taskId,
        planId:route.query.planId,
        sectionId:route.query.sectionId
      }
    }
  },
  {
    path: '/Complete',
    name: 'Complete',
    component: Complete,
	meta: {
	    requireAuth: true,
	},
    props:(route) => {
      return {
        recordId:route.query.recordId,
        evidence:route.query.evidence,
        planId:route.query.planId,
        sectionId:route.query.sectionId
      }
    }
  },
  {
    path: '/Error',
    name: 'Error',
    component: Error
  },
  {
    path: '/GoBack',
    name: 'GoBack',
    component: GoBack
  },
  {
    path: '/report/g3',
    name: 'G3 Report',
    component: G3Report,
	meta: {
	    requireAuth: true,
	},
    props:(route) => {
      return {
        summaryId:route.query.summaryId
      }
    }
  },
  {
	  path: '/report/machine',
	  component: machineReport,
	  meta: {
	      requireAuth: false,
	  }
  },
  {
    path: '/info/g3',
    name: 'G3 Info Input',
    component: G3InfoInput,
    meta: {
      requireAuth: true,
    },
    props:(route) => {
      return {
        summaryId:route.query.summaryId
      }
    }
  },
  {
    path: '/info/g3/v2',
    name: 'G3 Info Input v2',
    component: G3InfoInputV2,
    meta: {
      requireAuth: true,
    },
    props:(route) => {
      return {
        summaryId:route.query.summaryId
      }
    }
  },
  {
    path: '/info/infoInputV3',
    name: 'Info Input v3',
    component: InfoInputV3,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/info/g3/healthQuestionnaire',
    name: 'G3 Info Input healthQuestionnaire',
    component: healthQuestionnaire,
    meta: {
      requireAuth: true,
    },
    props:(route) => {
      return {
        summaryId:route.query.summaryId
      }
    }
  },
  {
    path: '/dynamicQuestionnaire',
    name: 'dynamicQuestionnaire',
    component: dynamicQuestionnaire,
    props:(route) => {
    }
  },
  {
    path: '/surveyList',
    name: '瑞金医院帕金森研究线上初筛工具',
    component: surveyList,
	meta: {
	  title: '瑞金医院帕金森研究线上初筛工具',
	  requireAuth: true,
	},
    props:(route) => {
    }
  },
  {
    path: '/surveyList/zhongshan',
    name: '中山大学肿瘤防治中心线上初筛工具',
    component: surveyListZhongShan,
  	meta: {
  	  title: '中山大学肿瘤防治中心线上初筛工具',
  	  requireAuth: true,
  	},
    props:(route) => {
    }
  },
  {
    path: '/intro/g3',
    name: 'G3 Introduce',
    component: G3Introduce,
    meta: {
      requireAuth: true,
    },
    props:(route) => {
      return {
        goReport:route.query.goReport
      }
    }
  },
  {
    path: '/transfer-guide/g3',
    name: '完成评测',
    component: G3TransferGuide,
    meta: {
      requireAuth: false,
    }
  },
  {
    path: '/transfer-check/g3',
    name: '信息检查中',
    component: G3TransferCheck,
    meta: {
      requireAuth: true,
    }
  },
  {
    path: '/intro-history/g3',
    name: 'G3 Introduce',
    component: G3IntroduceHistory,
    meta: {
      requireAuth: true,
    },
    props:(route) => {
      return {
        goReport:route.query.goReport
      }
    }
  },
  {
    path: '/intro/insurance',
    name: 'InsuranceIntroduce',
    // meta: {
    //     requireAuth: true,
    // },
    // component: InsuranceIntroduce,
	component: Introduce,
    props:(route) => {
      return {

      }
    }
  },
  {
    path: '/agreement',
    name: 'User Agreement',
	meta: {
	    requireAuth: true,
	},
    component: Agreement
  },
  {
    path: '/privacy',
    name: 'User Privacy',
    component: Privacy
  },
  {
    path: '/cps/index',
    name: 'Cps Home',
	 meta: {
	    requireAuth: true,
	},
    component: Home
  },
  {
    path: '/g3/pre/intro',
    name: 'Heng G3',
  	 meta: {
  	    requireAuth: false,
  	},
    component: G3PreIntro
  },
  {
    path: '/g3/pre/intro1',
    name: 'Heng G3',
	 meta: {
	    requireAuth: false,
	},
    component: G3PreIntro
  },
  {
    path: '/alipayH5',
    name: 'alipayH5',
	meta: {
	    requireAuth: true,
	},
    component: () => import('../pages/alipayH5')
  },
  {
    path: '/wechatH5',
    name: 'wechatH5',
	meta: {
	    requireAuth: true,
	},
    component: WechatH5
  },
  {
    path: '/g3-information',
    name: 'G3Information',
	meta: {
	    requireAuth: true,
	},
    component: G3Information
  },
  {
    path: '/face-example',
    name: 'FaceExample',
	meta: {
	    requireAuth: true,
	},
    component: FaceExample
  },
  {
    path: '/face-recognition',
    name: 'FaceRecognition',
	meta: {
	    requireAuth: true,
	},
    component: FaceRecognition
  },
  {
    path: '/bbrt-confirm',
    name: 'BBRTConfirm',
    component: BBRTConfirm
  },
  {
    path: '/Login',
    name: 'login',
    component: Login
  },
  {
    path: '/SCS/Report/:summaryId',
    name: 'SCSReport',
    component: SCSReport
  },
  {
    path: '/ZA/Insure',
    name: 'Insure',
    meta: {
      requireAuth: true,
    },
    component: Insure
  },
  {
    path: '/ZA/Introduce',
    name: 'Introduce',
    component: Introduce
  },
  {
    path: '/ZA/EnsureDetails',
    name: 'EnsureDetails',
		meta: {
			requireAuth: true,
		},
    component: EnsureDetails
  },
  {
    path: '/ZA/HealthNotification',
    name: 'HealthNotification',
		meta: {
			requireAuth: true,
		},
    component: HealthNotification
  },
    {
        path: '/ZA/Success',
        name: 'Success',
		meta: {
			requireAuth: true,
		},
        component: Success
    },
    {
        path: '/ZA/OrderDetails',
        name: 'OrderDetails',
		meta: {
			requireAuth: true,
		},
        component: OrderDetails
    },
    {
        path: '/ZA/InfoConfirm',
        name: 'InfoConfirm',
		meta: {
			requireAuth: true,
		},
        component: InfoConfirm
    },
    {
        path: '/agent/Login',
        name: '登录',
        component: agentLogin
    },
    {
        path: '/agent/My',
        name: '我的代理',
        component: agentMy
    },
    {
      path: '/product/use',
      name: '产品使用',
	  meta: {
	      requireAuth: true,
	  },
      component: productUse
    },
    {
      path: '/user/beha/path',
      name: '用户行为路径',
	  meta: {
	      requireAuth: true,
	  },
      component: userBehaPath
    },
    {
      path: '/user/source',
      name: '用户来源追踪',
	  meta: {
	      requireAuth: true,
	  },
      component: userSource
    },
    {
      path: '/personal/link',
      name: '专属链接',
	  meta: {
	      requireAuth: true,
	  },
      component: personalLink
    },
    {
      path: '/user/profile',
      name: '用户档案',
	  meta: {
	      requireAuth: true,
	  },
      component: userProfile
    },{
      path: '/user/tag',
      name: '用户标签',
	  meta: {
	      requireAuth: true,
	  },
      component: userTag
    },
    {
        path: '/user/report',
        name: '用户报告',
        meta: {
            requireAuth: true,
        },
        component: userReport
    },
    {
        path: '/user/report/list',
        name: '用户报告列表',
        meta: {
            requireAuth: true,
        },
        component: userReportList
    },
	{
	    path: '/user/train/report/list',
	    name: '用户报告列表',
	    meta: {
	        requireAuth: false,
	    },
	    component: userTrainReportList
	},
	
    {
      path: '/Bind/success',
      name: 'scanCode',
      component: scanCode
  },
  {
    path: '/contactKefu/contactKefu',
    name: '',
    component: cantactKefu
  },

  {
    path: '/contactKefu/contactKefu',
    name: '',
    component: cantactKefu
  },
    {
        path: '/agent/ordeDetails',
        name: '订单明细',
        component: agentOrdeDetails
    },
    {
        path: '/agent/withdrawalDetails',
        name: '提现明细',
        component: agentWithdrawalDetails
    },
    {
        path: '/ZA/ProductConfirm',
        name: 'ProductConfirm',
        meta: {
            requireAuth: true,
        },
        component: ProductConfirm
    },
    {
      path: '/opening-day',
      name: 'opening-day',
      meta: {
          requireAuth: false,
      },
      component: openingDay
    },
	{
	  path: '/productFactory',
	  name: 'productFactory',
	  component: productFactory
	},
	{
	  path: '/lotteryDrainage',
	  name: 'lotteryDrainage',
	  component: lotteryDrainage
	},
	{
	  path: '/luckyDraw',
	  name: 'luckyDraw',
	  component: luckyDraw
	},
    {
	  path: '/prizeDetail',
	  name: 'prizeDetail',
	  component: prizeDetail
	},
	{
      path: '/transitPage',
      name: 'transitPage',
      component: transitPage
    },
	{
      path: '/dynamic/dynamic',
      name: 'dynamicPage',
      component: dynamicPage
    },
	{
		path: '/turtleSoup',
		name: '每日海龟汤',
		component: turtleSoup

	},
	{
		path: '/aiChat',
		name: 'AI智能对话',
		component: aiChat

	}
]

const router = new VueRouter({
  mode: 'history',
  base: '/bst',
  routes,
  scrollBehavior (to, from, savedPosition) {
    // console.log(to,from,savedPosition)
    if(to.name === 'Product' && from.name === 'User Agreement'){
      // return {x:0,y:3000}
    }else{
      return {x:0,y:0}
    }
  }
})

router.beforeEach((to, from, next) => {
	if(to.name === 'SCSReport'){
        document.title = 'SCS认知风险评估报告';
    }else if(to.meta.title){
        document.title = to.meta.title;
    }else{
        document.title = '脑健康筛查训练';
    }
    if (to.meta.requireAuth) {
        let accessToken = sessionStorage.getItem("pa.accessToken");
        console.info('route accessToken is ', accessToken);
		let actionId = to.query.actionId;
		console.info('route actionId is ', actionId);
		if(actionId && !accessToken){
			accessToken = actionId;
			sessionStorage.setItem("pa.accessToken", accessToken);
		}
        if (accessToken) {
          next()
        } else {
          if(to.path==="/login"){
            next()
          }else{
              next({
                  path:"/login",
                  query: {...to.query,redirect: JSON.stringify({path: to.path, query: to.query})}//在原有参数基础上添加redirect参数
              })
          }
        }
    }
    else {
        next();
    }
})

export default router
